var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var _ = require('underscore');

// Job Area
module.exports = React.createClass({
	
	getInitialState : function(){
		return {
			map_mode : 'normal'
		};
	},
	
	componentDidMount : function(){
	  	
	  	this.showMap();
  	},
  	
  	showMap : function(){
  		console.log('show map', this.props);
	  	if(this.props.lat != 0 && this.props.lng != 0){
	  		
	  		console.log(this.props.map_display_mode);
	  		
	  		var zoom = 10;
	  		
	  		if(!_.isUndefined(this.props.map_zoom_level)){
		  		zoom = parseInt(this.props.map_zoom_level);
	  		}
	  		
		  	// Load google map
			var myLatlng = new google.maps.LatLng(this.props.lat, this.props.lng);
								
			// Map options
			var myOptions = {
				zoom : zoom,
				center : myLatlng,
				mapTypeId : google.maps.MapTypeId.ROADMAP
			};
					
			var map = new google.maps.Map($('.map')[0], myOptions);
			
			// Marker options
			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(this.props.lat, this.props.lng),
		       	map		: map,
		      	title	: 'Map title'
		  	});
			
			if(this.props.map_display_mode == 'map_view'){
				google.maps.event.trigger(map, "resize");	
			}
			
			if(this.props.map_display_mode == 'street_view'){
				
				var panoramaOptions = {
					position: myLatlng,
					pov: {
						heading: 90,
						pitch: 0,
						zoom: 0
					},
					
					linksControl: false,
		    			navigationControlOptions: {
			    		style: google.maps.NavigationControlStyle.SMALL
			    	}
			    };
			    
				var panorama = new  google.maps.StreetViewPanorama($('.map')[0], panoramaOptions);
	  	
				map.setStreetView(panorama);	
			}
		}
  	},
  	
  	mapShowDirections : function(){
  		
  		var self = this;
  		
	  	var markers = [
			{
				title : 'Current location',
				lat : self.state.coords.latitude,
				lng : self.state.coords.longitude
			},
			{
				title : self.props.address,
				lat : self.props.lat,
				lng : self.props.lng
			}
		];
			
		var mapOptions = {
	    	center: new google.maps.LatLng(markers[0].lat, markers[0].lng),
	        zoom: 12,
	        mapTypeId: google.maps.MapTypeId.ROADMAP
		};
	        
	    var map = new google.maps.Map($('.map')[0], mapOptions);
	        
	    var infoWindow = new google.maps.InfoWindow();
		var lat_lng = new Array();
		var latlngbounds = new google.maps.LatLngBounds();
		for (i = 0; i < markers.length; i++){
	            
	    	var data = markers[i]
	            
	        var myLatlng = new google.maps.LatLng(data.lat, data.lng);
	            
	        lat_lng.push(myLatlng);
	            
	        var marker = new google.maps.Marker({
	            position: myLatlng,
	            map: map,
	            title: data.title
	        });
	            
	        latlngbounds.extend(marker.position);
	            
	        (function (marker, data) {
	            google.maps.event.addListener(marker, "click", function (e) {
	                infoWindow.setContent(data.title);
	                infoWindow.open(map, marker);
	            });
	        })(marker, data);
	    }
	    map.setCenter(latlngbounds.getCenter());
		map.fitBounds(latlngbounds);
	 
	    //***********ROUTING****************//
		
		var totalDistance = 0;
		var totalDuration = 0;
		
	    //Initialize the Path Array
	    var path = new google.maps.MVCArray();
	 
		//Initialize the Direction Service
	    var service = new google.maps.DirectionsService();
		
	    //Set the Path Stroke Color
	    var poly = new google.maps.Polyline({ map: map, strokeColor: '#4986E7' });
	 
	    //Loop and Draw Path Route between the Points on MAP
	    for (var i = 0; i < lat_lng.length; i++) {
	    	if ((i + 1) < lat_lng.length) {
	 	        var src = lat_lng[i];
	            var des = lat_lng[i + 1];
	            path.push(src);
	            poly.setPath(path);
	            service.route({
	                origin: src,
	                destination: des,
	                travelMode: google.maps.DirectionsTravelMode.DRIVING
	            }, function (result, status) {
	            	if (status == google.maps.DirectionsStatus.OK) {
	            		var legs = result.routes[0].legs;
						for(var i=0; i<legs.length; ++i) {
						    totalDistance += legs[i].distance.value;
						    totalDuration += legs[i].duration.value;
						}
		
	                	for (var i = 0, len = result.routes[0].overview_path.length; i < len; i++) {
	                    	path.push(result.routes[0].overview_path[i]);
	                    }
	                    
	                    var km = Math.round(totalDistance/1000);
	                    var time = Math.round(totalDuration/60);
	                    $('.map-distance-info').empty().append(km+'km ('+time+' minutes by car)');
	                    console.log('distance: ', totalDistance, totalDuration);
	                }
	            });
	        }
	    }	
  	},
  	
  	componentDidUpdate : function(){
		
		var self = this;
		
		// Directions
		if(self.state.map_mode === 'directions'){
			self.mapShowDirections();
		} else {
			self.showMap();
		}
  	},
  	
  	toggleDirections : function(){
  		var self = this;
  		
  		navigator.geolocation.getCurrentPosition(function(position) {
			self.setState({
				map_mode : 'directions',
				coords : position.coords
			});
  		});
	  	//this.setState({ map_mode : 'directions' });
  	},
  	
  	toggleMap : function(){
  		var self = this;
  		
  		self.setState({
	  		map_mode : 'normal',
		});
  	},
  	
	// Render
  	render: function(){
  		
  		var classes = (this.props.lat == 0 || this.props.lng == 0) ? 'job-map hide' : 'job-map';
   		
   		var distanceElement = "";
   		var directionsButton = "";
   		var mapButton = "";
   		
   		if(this.state.map_mode === 'normal'){
	   		//directionsButton = (<div onClick={this.toggleDirections} className="map-directions"><span className="fa icon fa-map-marker"></span>Get directions</div>);
   		} else {
	   		mapButton = (<div onClick={this.toggleMap} className="map-button"><span className="fa icon fa-map"></span>Show map</div>);
	   		distanceElement = (<div className="map-distance-info"></div>);
   		}
   		
   		return (
   			<div className={classes}>
   				<div className="map"></div>
   				{distanceElement}
   				{mapButton}
   				{directionsButton}
   				
   				<div className="clear"></div>
	  		</div>
	  	);
	}
});
